import { Flex } from '@mantine/core';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { useSelectedMonthlyAveragesMeasures } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { useMonthlyAveragesData } from '../../hooks/monthly-averages';
import { MonthlyAveragesTable } from './table/table';

export const MonthlyAverages = () => {
  const selectedMonthlyAveragesMeasures = useSelectedMonthlyAveragesMeasures();
  const { data, isFetching } = useMonthlyAveragesData();

  if (!isFetching && (!data || Object.keys(data).length === 0)) {
    return <ContentPlaceholder />;
  }

  if (selectedMonthlyAveragesMeasures.length === 0) {
    return <ContentPlaceholder noFiltersApplied />;
  }

  return (
    <Flex direction="column" h="100%" w="100%" pos="relative">
      <MonthlyAveragesTable data={data} />
    </Flex>
  );
};
